import axios from "axios";
import store from "../store";
import {OauthUrl, SteamNodeUrl, url} from "./url";
import {getRefreshToken, getCookie, getSession, getAuthCode, getSteamId} from "./util";

export function queryItemList(data) {
  return axios({
    method: 'post',
    url: url + '/steam/queryItemList/v2',
    dataType: 'json',
    data,
    header: {
      'Content-Type': 'application/json'
    }
  })
}

export function allWeaponCasePriceRange(data) {
  return axios({
    method: 'get',
    url: url + '/steam/allWeaponCasePriceRange',
    dataType: 'json',
    params: data
  })
}

export function currentSelling() {
  return axios({
    method: 'get',
    url: url + '/biz/getUserSellings',
    dataType: 'json',
    params: {},
    headers: {
      'refresh_token': getRefreshToken(),
      "steamCookies": getCookie()
    }
  })
}

export function createSteamTargets(data) {
  return axios({
    method: 'get',
    url: url + '/biz/createSteamTarget',
    dataType: 'json',
    params: data,
    headers: {
      'refresh_token': getRefreshToken(),
      "steamCookies": getCookie(),
      "sessionId": getSession()
    }
  })
}

export function cancelSteamTarget(data) {
  return axios({
    method: 'get',
    url: url + '/biz/cancelSteamTarget',
    dataType: 'json',
    params: data,
    headers: {
      'refresh_token': getRefreshToken(),
      "steamCookies": getCookie(),
      "sessionId": getSession()
    }
  })
}

export function createSteamSelling(data) {
  return axios({
    method: 'get',
    url: url + '/steam/createSteamSelling',
    dataType: 'json',
    params: data,
    headers: {
      "steamCookies": getCookie(),
      "steamId": getSteamId()
    }
  })
}

export function removeSelling(data) {
  return axios({
    method: 'get',
    url: url + '/base/removeSelling',
    dataType: 'json',
    params: data,
    headers: {
      "steamSession": getSession(),
      "steamCookies": getCookie()
    }
  })
}

export function validAuthCode(data){
  return axios({
    method: 'get',
    url: url + '/base/validAuthCode',
    dataType: 'json',
    params: data
  })
}

export function validAdmin(data){
  return axios({
    method: 'get',
    url: url + '/base/validAdmin',
    dataType: 'json',
    params: data
  })
}

export function requestSteamQRCode() {
  return axios({
    method: 'get',
    url: SteamNodeUrl + '/steam/getSteamQRCode',
    params: {}
  })
}

export function loginByConfirm(data) {
  return axios({
    method: 'get',
    url: SteamNodeUrl + '/steam/loginByConfirm',
    params: data
  })
}

export function loginByPassword(data) {
  return axios({
    method: 'get',
    url: SteamNodeUrl + '/steam/loginByPassword',
    params: data
  })
}

export function loginSteamCommunityConfirm(data) {
  return axios({
    method: 'get',
    url: SteamNodeUrl + '/steam/loginSteamCommunity/confirm',
    params: data
  })
}

export function loginSteamUser(data) {
  return axios({
    method: 'get',
    url: SteamNodeUrl + '/steam/loginSteamUser',
    params: data,
    headers: {
      'refresh_token': getRefreshToken()
    }
  })
}

export function auditDailyInfo(data) {
  return axios({
    method: 'get',
    url: url + '/steam/auditDailyInfo',
    dataType: 'json',
    params: data
  })
}


export function findAllWeaponCases(data) {
  return axios({
    method: 'get',
    url: url + '/steam/findAllWeaponCases',
    dataType: 'json',
    data,
    header: {
      'Content-Type': 'application/json'
    }
  })
}

export function marketOverView(data) {
  return axios({
    method: 'get',
    url: url + '/steam/marketOverView',
    headers: {
      'Content-Type': 'application/json'
    },
    params: data,
    responseType: 'json'
  })
}

export function marketOverViewInfo(data) {
  return axios({
    method: 'get',
    url: url + '/steam/marketOverViewInfo',
    headers: {
      'Content-Type': 'application/json'
    },
    params: data,
    responseType: 'json'
  })
}

export function dailyDiscount(data) {
  return axios({
    method: 'get',
    url: url + '/steam/dailyDiscount',
    headers: {
      'Content-Type': 'application/json'
    },
    params: data,
    responseType: 'json'
  })
}


export function allCsgoOptions(data) {
  return axios({
    method: 'get',
    url: url + '/steam/allCsgoOptions',
    dataType: 'json',
    data,
    header: {
      'Content-Type': 'application/json'
    }
  })
}

export function allCurrencyOptions(data) {
  return axios({
    method: 'get',
    url: url + '/steam/allCurrencyOptions',
    dataType: 'json',
    data,
    header: {
      'Content-Type': 'application/json'
    }
  })
}

export function getUserInventory(data) {
  return axios({
    method: 'get',
    url: url + `/steam/getUserInventory`,
    params: data,
    dataType: 'json',
    headers: {
      'Content-Type': 'application/json',
      "steamCookies": getCookie()
    }
  })
}

export function getMySteamBuyOrder() {
  return axios({
    method: 'get',
    url: url + `/biz/getMySteamBuyOrder`,
    params: {},
    dataType: 'json',
    headers: {
      'Content-Type': 'application/json',
      'refresh_token': getRefreshToken(),
      "steamCookies": getCookie()
    }
  })
}


export function getRecommandDMarketTargets(data) {
  return axios({
    method: 'post',
    url: url + `/dmarket/recommandTargets/list`,
    data,
    dataType: 'json',
    headers: {
      'Content-Type': 'application/json',
      'refresh_token': getRefreshToken()
    }
  })
}

export function createDMarketTarget(data) {
  return axios({
    method: 'post',
    url: url + `/dmarket/target/create`,
    data,
    dataType: 'json',
    headers: {
      'Content-Type': 'application/json',
      'refresh_token': getRefreshToken()
    }
  })
}

export function getDMarketTargets(data) {
  return axios({
    method: 'get',
    url: url + `/dmarket/targets/list`,
    params: data,
    dataType: 'json',
    headers: {
      'Content-Type': 'application/json',
      'refresh_token': getRefreshToken()
    }
  })
}

export function removeDMarketTargets(data) {
  return axios({
    method: 'get',
    url: url + `/dmarket/target/remove`,
    params: data,
    dataType: 'json',
    headers: {
      'Content-Type': 'application/json',
      'refresh_token': getRefreshToken()
    }
  })
}

export function tradeUpStatistics(data) {
  return axios({
    method: 'get',
    url: url + `/biz/tradeup/statistics`,
    params: data,
    dataType: 'json',
    headers: {
      'Content-Type': 'application/json',
      'refresh_token': getRefreshToken(),
      "steamCookies": getCookie()
    }
  })
}

export function tradeUpHistory(data) {
  return axios({
    method: 'get',
    url: url + `/biz/tradeup/history`,
    params: data,
    dataType: 'json',
    headers: {
      'Content-Type': 'application/json',
      'refresh_token': getRefreshToken()
    }
  })
}

export function updateUserEmail(data) {
  return axios({
    method: 'get',
    url: url + '/biz/updateUserEmail',
    dataType: 'json',
    params: data,
    headers: {
      'Content-Type': 'application/json',
      'refresh_token': getRefreshToken()
    }
  })
}

export function getUserTokenDetail(data) {
  return axios({
    method: 'get',
    url: url + '/biz/userToken/detail',
    dataType: 'json',
    params: data,
    headers: {
      'Content-Type': 'application/json',
      'refresh_token': getRefreshToken()
    }
  })
}

export function updateUserToken(data) {
  return axios({
    method: 'post',
    url: url + '/biz/userToken/update',
    dataType: 'json',
    data,
    headers: {
      'Content-Type': 'application/json',
      'refresh_token': getRefreshToken()
    }
  })
}

export function simulateTradeUp(data) {
  return axios({
    method: 'post',
    url: url + '/steam/simulateTradeUp',
    dataType: 'json',
    data,
    headers: {
      'Content-Type': 'application/json'
    }
  })
}

export function saveSimulateTradeUpTemplate(data) {
  return axios({
    method: 'post',
    url: url + '/biz/simulate/template/save',
    dataType: 'json',
    data,
    headers: {
      'Content-Type': 'application/json',
      'refresh_token': getRefreshToken()
    }
  })
}

export function allTradeUpTemplates(data) {
  return axios({
    method: 'get',
    url: url + '/steam/allTradeUpTemplates',
    dataType: 'json',
    params: data,
    headers: {
      'Content-Type': 'application/json'
    }
  })
}

export function getSimulateTemplateByPage(data) {
  return axios({
    method: 'get',
    url: url + '/steam/simulate/template/page',
    dataType: 'json',
    params: data,
    headers: {
      'Content-Type': 'application/json'
    }
  })
}

export function craft(data) {
  return axios({
    method: 'post',
    url: SteamNodeUrl + '/steam/craft',
    dataType: 'json',
    data,
    headers: {
      'Content-Type': 'application/json',
      'refresh_token': getRefreshToken()
    }
  })
}

export function queryPaintWearPrice(data) {
  return axios({
    method: 'get',
    url: url + '/steam/paintWearStaff/price',
    dataType: 'json',
    params: data,
    headers: {
      'Content-Type': 'application/json'
    }
  })
}


export function getSteamSellingOrder(data) {
  return axios({
    method: 'get',
    url: url + `/biz/getSteamSellingOrder`,
    params: data,
    dataType: 'json',
    headers: {
      'Content-Type': 'application/json',
      'refresh_token': getRefreshToken()
    }
  })
}

export function loadRanking(data) {
  return axios({
    method: 'post',
    url: url + `/biz/loadRanking`,
    dataType: 'json',
    headers: {
      'Content-Type': 'application/json',
      'refresh_token': getRefreshToken()
    },
    data: data
  })
}

export function getAllPlatformOnSales() {
  return axios({
    method: 'get',
    url: url + `/steam/getAllPlatformOnSales`,
    dataType: 'json',
    headers: {
      'Content-Type': 'application/json',
      'Authorization': store.state.Authorization
    }
  })
}

export function queryItemsFromAllPlatform(data) {
  return axios({
    method: 'post',
    url: url + '/steam/queryItemsFromAllPlatform',
    dataType: 'json',
    data: data,
    headers: {
      'Content-Type': 'application/json'
    }
  })
}

export function favourStaff(data) {
  return axios({
    method: 'get',
    url: url + '/biz/favour',
    dataType: 'json',
    params: data,
    headers: {
      'Content-Type': 'application/json',
      'refresh_token': getRefreshToken()
    }
  })
}

export function saveFilterSearchForm(form) {
  return axios({
    method: 'post',
    url: url + '/biz/saveFilterSearchForm',
    data: form,
    headers: {
      'Content-Type': 'application/json',
      'authCode': getAuthCode()
    }
  })
}

export function getFilterSearchForm() {
  return axios({
    method: 'get',
    url: url + '/biz/getFilterSearchForm',
    dataType: 'json',
    params: {},
    headers: {
      'Content-Type': 'application/json',
      'authCode': getAuthCode()
    }
  })
}

export function deleteFilterSearchForm(data) {
  return axios({
    method: 'delete',
    url: url + '/biz/deleteFilterSearchForm',
    dataType: 'json',
    params: data,
    headers: {
      'Content-Type': 'application/json',
      'authCode': getAuthCode()
    }
  })
}

export function getAccessTokenByRefreshToken(data) {
  return axios({
    method: 'get',
    url: OauthUrl + '/oauth/v1/getAccessTokenByRefreshToken',
    dataType: 'json',
    params: data,
    headers: {
      'Content-Type': 'application/json'
    }
  })
}

// export function getUserInfo(data) {
//   return axios({
//     method: 'get',
//     url: OauthUrl + '/openapi/users/v1/getUserInfo',
//     dataType: 'json',
//     params: data,
//     headers: {
//       'Content-Type': 'application/json'
//     }
//   })
// }

export function getUserInfo(data) {
  return axios({
    method: 'get',
    url: SteamNodeUrl + '/steam/getUserInfo',
    dataType: 'json',
    params: data,
    headers: {
      'Content-Type': 'application/json',
      'refresh_token': getRefreshToken()
    }
  })
}

export function getUserInfoByAuthCode() {
  return axios({
    method: 'get',
    url: SteamNodeUrl + '/steam/authCode/getUserInfo',
    dataType: 'json',
    params: {},
    headers: {
      'Content-Type': 'application/json',
      'authCode': getAuthCode()
    }
  })
}

export function logOff(data) {
  return axios({
    method: 'get',
    url: SteamNodeUrl + '/steam/logOff',
    dataType: 'json',
    params: data,
    headers: {
      'Content-Type': 'application/json',
      'refresh_token': getRefreshToken()
    }
  })
}


export function remoteSearchOptions(data) {
  return axios({
    method: 'get',
    url: url + '/steam/remoteSearchOptions',
    dataType: 'json',
    params: data,
    headers: {
      'Content-Type': 'application/json'
    }
  })
}

export function simulateRemoteOptions(data) {
  return axios({
    method: 'post',
    url: url + '/steam/simulate/remoteOptions',
    dataType: 'json',
    data,
    headers: {
      'Content-Type': 'application/json'
    }
  })
}

export function getUSDTBalance(data) {
  return axios({
    method: 'get',
    url: url + '/biz/getUSDTBalance',
    dataType: 'json',
    params: data,
    headers: {
      'Content-Type': 'application/json',
      'refresh_token': getRefreshToken()
    }
  })
}


export function sendEmailVerifyCode(data) {
  return axios({
    method: 'get',
    url: url + '/biz/sendEmailVerifyCode',
    dataType: 'json',
    params: data,
    headers: {
      'Content-Type': 'application/json',
      'refresh_token': getRefreshToken()
    }
  })
}


export function modifyEmail(data) {
  return axios({
    method: 'get',
    url: url + '/biz/modifyEmail',
    dataType: 'json',
    params: data,
    headers: {
      'Content-Type': 'application/json',
      'refresh_token': getRefreshToken()
    }
  })
}

export function createRecharge(data) {
  return axios({
    method: 'get',
    url: url + '/recharge/create',
    dataType: 'json',
    params: data,
    headers: {
      'Content-Type': 'application/json'
    }
  })
}

export function rechargeOrderDetail(t_order_num) {
  return axios({
    method: 'get',
    url: url + `/recharge/info/${t_order_num}`,
    dataType: 'json',
    params: {},
    headers: {
      'Content-Type': 'application/json'
    }
  })
}

export function getRealTimeData(params){
  return axios({
    method: 'get',
    url: url + `/pricing/realTime`,
    dataType: 'json',
    params: params
  })
}

export function queryWearStaff(params){
  return axios({
    method: 'get',
    url: url + `/steam/emailSubcribtionItems`,
    dataType: 'json',
    params: params
  })
}

export function unusualChange(params){
  return axios({
    method: 'get',
    url: url + `/steam/unusual/change`,
    dataType: 'json',
    params: params
  })
}

export function exportDMarketExcel(params){
  return axios({
    method: 'get',
    url: url + `/dmarket/export/dmarketExcel`,
    dataType: 'json',
    params: params,
    responseType: 'blob' // 以 blob 格式接收文件
  })
}



// WEBPACK FOOTER //
// ./src/api/api.js